"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UNIVERSAL_SETTING_TYPE = void 0;
exports.UNIVERSAL_SETTING_TYPE = {
    STRING: 'STRING',
    NUMBER: 'NUMBER',
    OBJECT: 'OBJECT',
    NUMBER_ARRAY: 'NUMBER_ARRAY',
    STRING_ARRAY: 'STRING_ARRAY'
};
//# sourceMappingURL=universalSettingType.js.map